/**
 * Aluminium locker boxes: Logo Colour only applies for Kenworth logo / Custom logo.
 * N/A is a hidden variant value (never shown); selecting No logo checks it before
 * Horizon's variant-picker reads option value IDs (prevents page crash).
 */
(function () {
  'use strict';

  var LOGO_OPTION = 'Logo';
  var LOGO_COLOUR_OPTION = 'Logo Colour';
  var NO_LOGO = 'No logo';
  var NA_COLOUR = 'N/A';

  function optionNameFromLegend(legend) {
    if (!legend) return '';
    var clone = legend.cloneNode(true);
    var sw = clone.querySelector('.variant-option__swatch-value');
    if (sw) sw.remove();
    return String(clone.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function fieldsetByOptionName(picker, optionName) {
    var fieldsets = picker.querySelectorAll('fieldset.variant-option[data-fieldset-index]');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      if (optionNameFromLegend(fs.querySelector('legend')) === optionName) return fs;
    }
    return null;
  }

  function logoColourSelect(picker) {
    var selects = picker.querySelectorAll('select.variant-option__select');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      var name = sel.getAttribute('name') || '';
      if (name.indexOf(LOGO_COLOUR_OPTION) !== -1) return sel;
    }
    return null;
  }

  function getCheckedValue(fieldset) {
    if (!fieldset) return '';
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? String(checked.value || '').trim() : '';
  }

  function firstVisibleColourInput(fieldset) {
    if (!fieldset) return null;
    var inputs = fieldset.querySelectorAll('input[type="radio"]:not(.ctc-logo-colour-na)');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.disabled) continue;
      var label = input.closest('label');
      if (label && label.hasAttribute('hidden')) continue;
      return input;
    }
    return inputs[0] || null;
  }

  function naInput(fieldset) {
    return fieldset ? fieldset.querySelector('input.ctc-logo-colour-na') : null;
  }

  function applyLogoColourState(picker, logoValue) {
    var logoFieldset = fieldsetByOptionName(picker, LOGO_OPTION);
    var colourFieldset = fieldsetByOptionName(picker, LOGO_COLOUR_OPTION);
    var colourSelect = logoColourSelect(picker);
    var logo = logoValue || getCheckedValue(logoFieldset);
    var noLogo = logo === NO_LOGO;

    if (colourFieldset) {
      if (noLogo) {
        colourFieldset.dataset.ctcManagedHidden = 'logo-colour';
      } else {
        delete colourFieldset.dataset.ctcManagedHidden;
      }
      colourFieldset.hidden = noLogo;
      colourFieldset.setAttribute('aria-hidden', noLogo ? 'true' : 'false');

      var na = naInput(colourFieldset);
      if (noLogo && na) {
        colourFieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          radio.checked = false;
          radio.dataset.currentChecked = 'false';
        });
        na.checked = true;
        na.dataset.currentChecked = 'true';
      } else if (!noLogo) {
        if (na && na.checked) {
          na.checked = false;
          na.dataset.currentChecked = 'false';
        }
        var current = getCheckedValue(colourFieldset);
        if (!current || current === NA_COLOUR) {
          var first = firstVisibleColourInput(colourFieldset);
          if (first) {
            first.checked = true;
            first.dataset.currentChecked = 'true';
          }
        }
      }
    }

    if (colourSelect) {
      var wrapper = colourSelect.closest('.variant-option--dropdowns');
      if (wrapper) {
        if (noLogo) {
          wrapper.dataset.ctcManagedHidden = 'logo-colour';
        } else {
          delete wrapper.dataset.ctcManagedHidden;
        }
        wrapper.hidden = noLogo;
        wrapper.setAttribute('aria-hidden', noLogo ? 'true' : 'false');
      }
      var naOption = colourSelect.querySelector('option.ctc-logo-colour-na');
      if (noLogo && naOption) {
        colourSelect.value = NA_COLOUR;
      } else if (!noLogo && colourSelect.value === NA_COLOUR) {
        var fallback = colourSelect.querySelector('option:not(.ctc-logo-colour-na)');
        if (fallback) colourSelect.value = fallback.value;
      }
    }
  }

  function blockNaInteraction(picker) {
    var colourFieldset = fieldsetByOptionName(picker, LOGO_COLOUR_OPTION);
    if (!colourFieldset) return;

    colourFieldset.addEventListener(
      'click',
      function (e) {
        var input =
          e.target instanceof HTMLInputElement
            ? e.target
            : e.target.closest('label')?.querySelector('input[type="radio"]');
        if (!input) return;
        if (input.value === NA_COLOUR || input.classList.contains('ctc-logo-colour-na')) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function wirePicker(picker) {
    if (picker.dataset.ctcLockerLogoColourWired === 'true') return;

    var logoFieldset = fieldsetByOptionName(picker, LOGO_OPTION);
    var colourFieldset = fieldsetByOptionName(picker, LOGO_COLOUR_OPTION);
    var colourSelect = logoColourSelect(picker);
    if (!logoFieldset || (!colourFieldset && !colourSelect)) return;

    picker.dataset.ctcLockerLogoColourWired = 'true';

    logoFieldset.addEventListener(
      'change',
      function (e) {
        if (!(e.target instanceof HTMLInputElement) || e.target.type !== 'radio') return;
        applyLogoColourState(picker, e.target.value);
      },
      true
    );

    if (colourSelect) {
      var logoSelect = picker.querySelector('select[name*="Logo"]');
      if (logoSelect) {
        logoSelect.addEventListener(
          'change',
          function () {
            applyLogoColourState(picker, logoSelect.value);
          },
          true
        );
      }
    }

    blockNaInteraction(picker);
    applyLogoColourState(picker, getCheckedValue(logoFieldset));
  }

  function scan() {
    document.querySelectorAll('variant-picker[data-product-url]').forEach(wirePicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);

  var globalObs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        scan();
        return;
      }
    }
  });
  globalObs.observe(document.documentElement, { subtree: true, childList: true });
})();
